import { useEffect, useState } from 'react';

export function useDebouncedValue<TValue>(value: TValue, delay: number | null) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        // If no delay, immediately update debounced value
        if (delay == null) {
            setDebouncedValue(value);
            return;
        }

        const handle = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handle);
        };
    }, [value, delay]);

    // If no delay, return value immediately
    return delay != null ? debouncedValue : value;
}
